export const version = 'HEAD';
export const buildDate = '2026-02-05T00:37:26.746Z';
export const commitHash = '0eddff3';